import { useCallback, useContext, useEffect, useState } from 'react';
import { AudioRecorderContext } from '../context/audio-recorder-context';
import { useExternalState } from './use-external-state';

export const useInputList = () => {
  const ctx = useContext(AudioRecorderContext);
  const inputs = useExternalState(ctx.recorder!.inputState)
  return inputs;
}